module.exports = __webpack_public_path__ + "logo-woocommerce.8d627b20940d7d56a2bb517d960212e3.svg";